import { useState } from 'react';

import { useDeleteOrder } from '#api-bridge/orderApi.ts';

export type CancelSelectedOpenOrdersResult = {
    failureCount: number;
};

export const useCancelSelectedOpenOrders = () => {
    const [deleteOrder] = useDeleteOrder();
    const [isCancelingSelectedOpenOrders, setIsCancelingSelectedOpenOrders] = useState(false);

    const cancelSelectedOpenOrders = async (orderIds: string[]): Promise<CancelSelectedOpenOrdersResult> => {
        setIsCancelingSelectedOpenOrders(true);
        try {
            const resolvedPromises = await Promise.allSettled(orderIds.map(orderId => deleteOrder(orderId).unwrap()));
            const failureCount = resolvedPromises.filter(promise => promise.status === 'rejected').length;

            return {
                failureCount,
            };
        } finally {
            setIsCancelingSelectedOpenOrders(false);
        }
    };

    return {
        cancelSelectedOpenOrders,
        isLoading: isCancelingSelectedOpenOrders,
    };
};
